import React, { useCallback, useContext } from 'react'

import ItemPriceAndCTAs from './common/ItemPriceAndCTAs'
import { DetailItemCardVariant } from './common/types'
import ExperienceCtaContent from './CTAContent/ExperienceCtaContent'
import { PlannedItemPriceContent } from './ItemOfferPrice/PlannedItemPriceContent'

import GeoContext from 'contexts/geoContext'
import useTrackExperienceOfferEvent from 'contexts/support/useTrackExperienceOfferEvent'
import { ExperienceItem } from 'tripPlanner/types/tripItem'
import { isLeBookmark } from 'tripPlanner/utils'
import { buildProductLink } from 'tripPlanner/utils/bookmark/restoreCart'
import { isExperienceAvailable } from 'tripPlanner/utils/experience'

interface Props {
  item: ExperienceItem
  experience: App.ExperienceOffer
  viewAsTemplate: boolean
  variant: DetailItemCardVariant
}

function ExperiencePriceAndCTAs({
  item,
  experience,
  viewAsTemplate,
  variant,
}: Props) {
  const { currentCurrency } = useContext(GeoContext)

  const trackEvent = useTrackExperienceOfferEvent()
  const handleExperienceClick = useCallback(() => {
    if (experience) {
      trackEvent('OFFER_TILE_CLICKED', [
        {
          type: 'click',
          data: {
            offer: experience,
          },
        },
      ])
    }
  }, [experience, trackEvent])

  let priceAreaContent: JSX.Element | null = null
  let offerLink: string | undefined = undefined
  let isOfferAvailable = true

  if (isLeBookmark(item)) {
    offerLink = buildProductLink(item, !viewAsTemplate, { experience }) ?? ''

    isOfferAvailable = experience
      ? isExperienceAvailable(experience, viewAsTemplate)
      : true

    if (viewAsTemplate) {
      priceAreaContent = experience ? (
        <PlannedItemPriceContent
          discountPercent={experience.discount}
          price={experience.price}
          currencyCode={currentCurrency}
          isOfferAvailable={isOfferAvailable}
        />
      ) : null
    } else {
      const { price, discountPercent, currencyCode } = item.savedItemData
      priceAreaContent = (
        <PlannedItemPriceContent
          discountPercent={discountPercent}
          price={price}
          currencyCode={currencyCode}
          isOfferAvailable={isOfferAvailable}
        />
      )
    }
  }

  const ctaAreaContent = (
    <ExperienceCtaContent
      item={item}
      variant={variant}
      offerLink={offerLink}
      isOfferAvailable={isOfferAvailable}
      onViewOffer={handleExperienceClick}
    />
  )

  return (
    <ItemPriceAndCTAs>
      {priceAreaContent && <div className="price-area">{priceAreaContent}</div>}
      {ctaAreaContent && <div className="cta-area">{ctaAreaContent}</div>}
    </ItemPriceAndCTAs>
  )
}

export default ExperiencePriceAndCTAs
